export default "__VITE_ASSET__mDmaoSEB__"